import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView, sendTimeOnPage } from '../services/analyticsApi';

export default function PageTracker() {
  const location = useLocation();
  const pageViewIdRef = useRef<number | null>(null);
  // Real value is always set by the mount effect below before it's read (pageViewIdRef
  // starts null, so the "send time for previous page" branch is skipped on first render).
  const enteredAtRef = useRef<number>(0);

  useEffect(() => {
    // Send time-on-page for the previous page
    const prevId = pageViewIdRef.current;
    const prevEntered = enteredAtRef.current;
    if (prevId) {
      sendTimeOnPage(prevId, Date.now() - prevEntered);
    }

    // Track new page view
    pageViewIdRef.current = null;
    enteredAtRef.current = Date.now();

    trackPageView({
      page_path: location.pathname,
      page_title: document.title,
      referrer: document.referrer || undefined,
    }).then((result) => {
      if (result) {
        pageViewIdRef.current = result.page_view_id;
      }
    });
  }, [location.pathname]);

  // Send time on page leave
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden' && pageViewIdRef.current) {
        sendTimeOnPage(pageViewIdRef.current, Date.now() - enteredAtRef.current);
      }
    };

    const handleBeforeUnload = () => {
      if (pageViewIdRef.current) {
        sendTimeOnPage(pageViewIdRef.current, Date.now() - enteredAtRef.current);
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  return null;
}
